module.exports = __webpack_public_path__ + "img/object-mark2.e3906b42.png";